import script from "./GenerateSnippetTagDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateSnippetTagDialog.vue?vue&type=script&setup=true&lang=js"

import "./GenerateSnippetTagDialog.vue?vue&type=style&index=0&id=1e31badc&lang=css"

const __exports__ = script;

export default __exports__